import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";

function checkWebGL2Support() {
    try {
        const canvas = document.createElement("canvas");
        return !!(window.WebGL2RenderingContext && canvas.getContext("webgl2"));
    } catch {
        return false;
    }
}

export default class WebGL2Message extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMessage: !checkWebGL2Support(),
        };
    }

    clear() {
        this.setState({ showMessage: false });
        this.props.onClose(0);
    }

    render() {
        return (
            <Dialog
                open={this.state.showMessage && !this.props.cleared}
                onClose={() => {
                    this.clear();
                }}
                aria-labelledby={"alert-dialog-title"}
                aria-describedby={"alert-dialog-description"}
            >
                <DialogTitle>Browser Update Required</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Your browser does not support WebGL2, which is required for some features to work properly.
                        Please update your browser to the latest version. On iOS devices, you may need to update your
                        operating system as well (Settings → General → Software Update).
                    </DialogContentText>
                    <br />
                    <DialogContentText>
                        If you think this message is appearing in error, check your WebGL2 support{" "}
                        <a
                            href={"https://get.webgl.org/webgl2/"}
                            target={"_blank"}
                            rel={"noopener noreferrer"}
                            className={"underline"}
                        >
                            here
                        </a>
                        . If you see a spinning cube, please contact our support team.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            this.clear();
                        }}
                        color={"primary"}
                    >
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
